import styled from 'styled-components';

export const StyledCardsContainer = styled.div`
    display: inline-grid;
    gap: 10px;
    max-height: 435px;
    overflow-y: scroll;
    @media (width > 415px) and (width <= 850px) {
        display: inline-grid;
        gap: 10px;
        overflow-y: scroll;
        width: 90%;
    }
    @media (width <= 460px) {
        width: unset;
    }
`;

export const CenterContentContainer = styled.div`
    display: flex;
    gap: 30px;
    @media (width <= 850px) {
        display: flex;
        gap: 30px;
        flex-direction: column;
    }
`;
